import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from "svelte";
import Sidebar from "../../node_modules/flowbite-svelte/dist/sidebar/Sidebar.svelte";
import SidebarGroup from "../../node_modules/flowbite-svelte/dist/sidebar/SidebarGroup.svelte";
import SidebarItem from "../../node_modules/flowbite-svelte/dist/sidebar/SidebarItem.svelte";
import { uiHelpers } from "../../node_modules/flowbite-svelte/dist/uiHelpers.svelte.js";
import DocRail from "./navigation/DocRail.svelte";
import Playground from "../../src/components/svelte/tooling/Playground.svelte";
import { bindPropStore } from "./bindProps";
import { emit, objects, text } from "./helpers";
import { getPhosphorIcon } from "../app/icons.js";

const persistedCollapsedSections = {};
var root = $.from_html(`<div class="slex-docs-subgroup-title"> </div>`);
var root_1 = $.from_html(`<div class="slex-docs-subgroup"><!> <div class="slex-docs-subgroup-items"></div></div>`);
var root_2 = $.from_html(`<button type="button"><span class="slex-docs-section-trigger-main"><span class="slex-docs-section-icon" aria-hidden="true"></span> <span> </span></span> <span class="slex-docs-section-caret" aria-hidden="true"></span></button> <div><div class="slex-docs-section-panel-inner"></div></div>`, 1);
var root_3 = $.from_html(`<div class="slex-docs-shell-playground"><!></div>`);
var root_4 = $.from_html(`<a class="slex-doc-detail-action" target="_blank" rel="noreferrer"><span class="slex-doc-detail-action-icon" aria-hidden="true"></span>Markdown</a>`);
var root_5 = $.from_html(`<a class="slex-doc-detail-action" target="_blank" rel="noreferrer"><span class="slex-doc-detail-action-icon" aria-hidden="true"></span> </a>`);
var root_6 = $.from_html(`<article class="slex-doc-detail"><div class="slex-doc-detail-content"><div class="slex-doc-detail-header"><div class="slex-doc-detail-actions slex-doc-detail-actions--content"><span class="slex-doc-detail-copy-action"><button type="button" class="slex-doc-detail-action"><span class="slex-doc-detail-action-icon" aria-hidden="true"></span> </button> <span class="slex-doc-detail-copy-feedback" aria-live="polite"> </span></span> <!> <!></div></div> <div class="slex-doc-prose"></div></div></article>`);
var root_7 = $.from_html(`<div class="slex-docs-shell-empty"> </div>`);
var root_8 = $.from_html(`<section class="slex-docs-shell"><aside class="slex-docs-shell-sidebar"><!></aside> <article class="slex-docs-shell-main"><div class="slex-docs-mobile-toolbar"><button type="button" class="slex-site-icon-button slex-docs-sidebar-trigger"><span aria-hidden="true"></span></button></div> <!> <!></article> <!></section>`);

export default function DocsShell($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let collapsedSections = $.state($.proxy({ ...persistedCollapsedSections }));
	const docsSidebarUi = uiHelpers();
	let isDocsSidebarOpen = $.state(false);
	const closeDocsSidebar = docsSidebarUi.close;
	let copyFeedback = $.state("");
	let copyFeedbackState = $.state("success");
	let copyFeedbackTimer;

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	$.user_effect(() => {
		$.set(isDocsSidebarOpen, docsSidebarUi.isOpen, true);
	});

	onDestroy(() => {
		if (copyFeedbackTimer) clearTimeout(copyFeedbackTimer);
	});

	const activeClass = "slex-docs-sidebar-item slex-docs-sidebar-item--active";
	const nonActiveClass = "slex-docs-sidebar-item";

	function labels() {
		const next = $.get(p).uiLabels && typeof $.get(p).uiLabels === "object" ? $.get(p).uiLabels : {};

		return {
			docsLabel: text(next.docsLabel, "\u6587\u6863"),
			copyPage: text(next.copyPage, "\u590d\u5236\u9875\u9762"),
			viewMarkdown: text(next.viewMarkdown, "\u67e5\u770b Markdown"),
			openLive: text(next.openLive ?? next.openLiveLabel, "\u4ee5 Live \u6a21\u5f0f\u6253\u5f00"),
			copiedPage: text(next.copiedPage, "\u5df2\u590d\u5236\u9875\u9762"),
			copyFailed: text(next.copyFailed, "\u590d\u5236\u5931\u8d25"),
			openDocsNavigation: text(next.openDocsNavigation, "\u6253\u5f00\u6587\u6863\u5bfc\u822a"),
			noDocsFound: text(next.noDocsFound, "\u6ca1\u6709\u627e\u5230\u6587\u6863\u3002"),
			onThisPage: text(next.onThisPage, "\u672c\u9875"),
			onThisPageAria: text(next.onThisPageAria, "\u672c\u9875\u76ee\u5f55")
		};
	}

	function markdownHref(doc) {
		if (doc.markdownHref === false) return "";

		const explicitHref = text(doc.markdownHref ?? $.get(p).markdownHref);

		if (explicitHref) return explicitHref;

		return `${text(doc.href, "/docs")}.md`;
	}

	function canOpenInPlayground(doc) {
		return text(doc.slexkitRenderMode) !== "dialog";
	}

	function playgroundHref(doc) {
		if (!canOpenInPlayground(doc)) return "";

		const explicitHref = text(doc.playgroundHref ?? doc.liveHref);

		if (explicitHref) return explicitHref;

		const href = markdownHref(doc);

		if (!href) return "";

		const params = new URLSearchParams({ mode: "live", type: "markdown", src: href });
		const base = text($.get(p).playgroundHrefBase ?? $.get(p).playgroundBaseHref, "/playground.html");

		return `${base}?${params.toString()}`;
	}

	function slugId(prefix, label) {
		return `${prefix}-${label.toLowerCase().replace(/[^a-z0-9\u4e00-\u9fa5]+/gi, "-").replace(/^-|-$/g, "") || "items"}`;
	}

	function normalizedSectionKey(value) {
		const normalized = value.toLowerCase();

		if (normalized === "guides" || value === "指南") return "guides";
		if (normalized === "components" || value === "组件") return "components";
		if (normalized === "reference" || value === "参考") return "reference";
		if (normalized === "releases" || value === "发布") return "releases";
		if (normalized.includes("api") || value === "API 参考") return "api";

		return normalized || "docs";
	}

	function sectionIcon(key, label) {
		if (key === "guides") return "lightbulb";
		if (key === "components") return "squares-four";
		if (key === "reference") return "book-open";
		if (key === "releases") return "tag";
		if (key === "api") return "database";

		const normalized = label.toLowerCase();

		if (normalized.includes("guide")) return "lightbulb";
		if (normalized.includes("component")) return "squares-four";
		if (normalized.includes("reference")) return "book-open";
		if (normalized.includes("release")) return "tag";
		if (normalized.includes("api")) return "database";

		return "book-open";
	}

	function buildSubgroups(sectionKey, items) {
		const orderedItems = sectionKey === "components"
			? [...items].sort((a, b) => text(a.title ?? a.label ?? itemId(a)).localeCompare(text(b.title ?? b.label ?? itemId(b)), "en"))
			: [...items];

		if (sectionKey === "components") {
			return [
				{
					id: slugId("docs-subgroup", sectionKey),
					label: "",
					items: orderedItems
				}
			];
		}

		return [
			{
				id: slugId("docs-subgroup", sectionKey),
				label: "",
				items: orderedItems
			}
		];
	}

	function sections() {
		const list = [];
		const byKey = new Map();

		for (const item of objects($.get(p).items)) {
			const label = text(item.group, "Docs");
			const key = normalizedSectionKey(text(item.groupKey, label));
			let section = byKey.get(key);

			if (!section) {
				section = {
					id: slugId("docs-section", key),
					key,
					label,
					icon: sectionIcon(key, label),
					items: [],
					subgroups: []
				};

				byKey.set(key, section);
				list.push(section);
			}

			section.items.push(item);
		}

		for (const section of list) section.subgroups = buildSubgroups(section.key, section.items);

		return list;
	}

	function itemId(item) {
		return text(item.id ?? item.slug ?? item.href);
	}

	function itemHref(item) {
		return text(item.href, item.id
			? `/docs/${encodeURIComponent(text(item.id))}`
			: "/docs");
	}

	function isItemActive(item) {
		const active = text($.get(p).active);
		const href = itemHref(item);
		const id = itemId(item);

		return active === href || active === id || active === text(item.slug);
	}

	function isSectionOpen(section) {
		if ($.get(collapsedSections)[section.id] !== undefined) return !$.get(collapsedSections)[section.id];

		return true;
	}

	function toggleSection(section) {
		const next = {
			...$.get(collapsedSections),
			[section.id]: isSectionOpen(section)
		};

		$.set(collapsedSections, next, true);
		Object.assign(persistedCollapsedSections, next);
	}

	async function copyText(value) {
		const content = text(value);

		if (!content) throw new Error("Nothing to copy.");

		if (navigator.clipboard?.writeText) {
			await navigator.clipboard.writeText(content);

			return;
		}

		const textarea = document.createElement("textarea");

		textarea.value = content;
		textarea.setAttribute("readonly", "");
		textarea.style.position = "fixed";
		textarea.style.opacity = "0";
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand("copy");
		textarea.remove();
	}

	function showCopyFeedback(message, state) {
		$.set(copyFeedback, message, true);
		$.set(copyFeedbackState, state, true);

		if (copyFeedbackTimer) clearTimeout(copyFeedbackTimer);

		copyFeedbackTimer = setTimeout(
			() => {
				$.set(copyFeedback, "");
				copyFeedbackTimer = undefined;
			},
			1800
		);
	}

	async function copyMarkdown(doc) {
		try {
			const markdown = text(doc.markdown);

			if (markdown) {
				await copyText(markdown);
				showCopyFeedback(labels().copiedPage, "success");

				return;
			}

			const href = markdownHref(doc);

			if (!href) throw new Error("Missing Markdown URL.");

			const response = await fetch(href);

			if (!response.ok) throw new Error(`Failed to load Markdown: ${response.status}`);

			await copyText(await response.text());
			showCopyFeedback(labels().copiedPage, "success");
		} catch {
			showCopyFeedback(labels().copyFailed, "error");
		}
	}

	var section_1 = root_8();
	var aside = $.child(section_1);
	var node = $.child(aside);

	{
		let $0 = $.derived(() => text($.get(p).active));
		let $1 = $.derived(() => text($.get(p).label, labels().docsLabel));

		Sidebar(node, {
			get activeUrl() {
				return $.get($0);
			},

			get isOpen() {
				return $.get(isDocsSidebarOpen);
			},

			get closeSidebar() {
				return closeDocsSidebar;
			},
			breakpoint: 'lg',
			backdrop: true,
			position: 'fixed',
			class: 'slex-docs-flowbite-sidebar h-full w-full bg-transparent p-0',
			classes: { active: activeClass, nonactive: nonActiveClass },
			get ariaLabel() {
				return $.get($1);
			},

			children: ($$anchor, $$slotProps) => {
				var fragment = $.comment();
				var node_1 = $.first_child(fragment);

				$.each(node_1, 17, sections, $.index, ($$anchor, section) => {
					SidebarGroup($$anchor, {
						class: 'slex-docs-section',
						children: ($$anchor, $$slotProps) => {
							var fragment_2 = root_2();
							var button = $.first_child(fragment_2);
							let classes;
							var span = $.child(button);
							var span_1 = $.child(span);

							$.html(span_1, () => getPhosphorIcon($.get(section).icon), true);
							$.reset(span_1);

							var span_2 = $.sibling(span_1, 2);
							var text_1 = $.child(span_2, true);

							$.reset(span_2);
							$.reset(span);

							var span_3 = $.sibling(span, 2);

							$.html(span_3, () => getPhosphorIcon("caret-down"), true);
							$.reset(span_3);
							$.reset(button);

							var div = $.sibling(button, 2);
							let classes_1;
							var div_1 = $.child(div);

							$.each(div_1, 21, () => $.get(section).subgroups, $.index, ($$anchor, subgroup) => {
								var div_2 = root_1();
								var node_2 = $.child(div_2);

								{
									var consequent = ($$anchor) => {
										var div_3 = root();
										var text_2 = $.child(div_3, true);

										$.reset(div_3);
										$.template_effect(() => $.set_text(text_2, $.get(subgroup).label));
										$.append($$anchor, div_3);
									};

									$.if(node_2, ($$render) => {
										if ($.get(subgroup).label) $$render(consequent);
									});
								}

								var div_4 = $.sibling(node_2, 2);

								$.each(div_4, 21, () => $.get(subgroup).items, $.index, ($$anchor, item) => {
									{
										let $0 = $.derived(() => text($.get(item).title ?? $.get(item).label ?? itemId($.get(item))));
										let $1 = $.derived(() => itemHref($.get(item)));
										let $2 = $.derived(() => text($.get(item).description ?? $.get(item).summary ?? $.get(item).title));
										let $3 = $.derived(() => isItemActive($.get(item)));

										SidebarItem($$anchor, {
											get label() {
												return $.get($0);
											},

											get href() {
												return $.get($1);
											},

											get title() {
												return $.get($2);
											},

											get active() {
												return $.get($3);
											},
											activeClass,
											nonActiveClass,
											spanClass: 'slex-docs-sidebar-item-label',
											onclick: (event) => {
												if ($.get(p).preventDefault === true) event.preventDefault();

												emit($$props.ctx, "select", {
													type: "select",
													target: $$props.ctx.id,
													id: itemId($.get(item)),
													href: itemHref($.get(item)),
													item: $.get(item),
													native: event
												});

												closeDocsSidebar();
											}
										});
									}
								});

								$.reset(div_4);
								$.reset(div_2);
								$.append($$anchor, div_2);
							});

							$.reset(div_1);
							$.reset(div);

							$.template_effect(
								($0, $1, $2, $3, $4) => {
									classes = $.set_class(button, 1, 'slex-docs-section-trigger', null, classes, $0);
									$.set_attribute(button, 'aria-expanded', $1);
									$.set_attribute(button, 'aria-controls', `${$.get(section).id}-panel`);
									$.set_text(text_1, $.get(section).label);
									$.set_attribute(div, 'id', `${$.get(section).id}-panel`);
									classes_1 = $.set_class(div, 1, 'slex-docs-section-panel', null, classes_1, $2);
									$.set_attribute(div, 'data-state', $3);
									$.set_attribute(div, 'aria-hidden', $4);
								},
								[
									() => ({
										'slex-docs-section-trigger--open': isSectionOpen($.get(section))
									}),
									() => isSectionOpen($.get(section)),
									() => ({
										'slex-docs-section-panel--open': isSectionOpen($.get(section))
									}),
									() => isSectionOpen($.get(section)) ? "open" : "closed",
									() => !isSectionOpen($.get(section))
								]
							);

							$.delegated('click', button, () => toggleSection($.get(section)));
							$.append($$anchor, fragment_2);
						},
						$$slots: { default: true }
					});
				});

				$.append($$anchor, fragment);
			},
			$$slots: { default: true }
		});
	}

	$.reset(aside);

	var article = $.sibling(aside, 2);
	var div_5 = $.child(article);
	var button_1 = $.child(div_5);
	var span_4 = $.child(button_1);

	$.html(span_4, () => getPhosphorIcon("list"), true);
	$.reset(span_4);
	$.reset(button_1);
	$.reset(div_5);

	var node_3 = $.sibling(div_5, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_6 = root_3();
			var node_4 = $.child(div_6);

			Playground(node_4, {
				componentName: 'playground',
				get ctx() {
					return $$props.ctx;
				},

				props: {
					subscribe: (run) => {
						run($.get(p).playground);

						return () => {};
					}
				}
			});

			$.reset(div_6);
			$.append($$anchor, div_6);
		};

		$.if(node_3, ($$render) => {
			if ($.get(p).playground && typeof $.get(p).playground === "object") $$render(consequent_1);
		});
	}

	var node_5 = $.sibling(node_3, 2);

	{
		var consequent_4 = ($$anchor) => {
			const doc = $.derived(() => $.get(p).doc);
			var article_1 = root_6();
			var div_7 = $.child(article_1);
			var div_8 = $.child(div_7);
			var div_9 = $.child(div_8);
			var span_5 = $.child(div_9);
			var button_2 = $.child(span_5);
			var span_6 = $.child(button_2);

			$.html(span_6, () => getPhosphorIcon("copy"), true);
			$.reset(span_6);

			var text_3 = $.sibling(span_6, 1, true);

			$.reset(button_2);

			var span_7 = $.sibling(button_2, 2);
			var text_4 = $.child(span_7, true);

			$.reset(span_7);
			$.reset(span_5);

			var node_6 = $.sibling(span_5, 2);

			{
				var consequent_2 = ($$anchor) => {
					var a_1 = root_4();
					var span_8 = $.child(a_1);

					$.html(span_8, () => getPhosphorIcon("markdown-logo"), true);
					$.reset(span_8);
					$.next();
					$.reset(a_1);

					$.template_effect(
						($0, $1) => {
							$.set_attribute(a_1, 'title', $0);
							$.set_attribute(a_1, 'href', $1);
						},
						[() => labels().viewMarkdown, () => markdownHref($.get(doc))]
					);

					$.append($$anchor, a_1);
				};

				var d = $.derived(() => markdownHref($.get(doc)));

				$.if(node_6, ($$render) => {
					if ($.get(d)) $$render(consequent_2);
				});
			}

			var node_7 = $.sibling(node_6, 2);

			{
				var consequent_3 = ($$anchor) => {
					var a_2 = root_5();
					var span_9 = $.child(a_2);

					$.html(span_9, () => getPhosphorIcon("square-split-horizontal"), true);
					$.reset(span_9);

					var text_5 = $.sibling(span_9, 1, true);

					$.reset(a_2);

					$.template_effect(
						($0, $1, $2) => {
							$.set_attribute(a_2, 'title', $0);
							$.set_attribute(a_2, 'href', $1);
							$.set_text(text_5, $2);
						},
						[
							() => labels().openLive,
							() => playgroundHref($.get(doc)),
							() => labels().openLive
						]
					);

					$.append($$anchor, a_2);
				};

				var d_1 = $.derived(() => playgroundHref($.get(doc)));

				$.if(node_7, ($$render) => {
					if ($.get(d_1)) $$render(consequent_3);
				});
			}

			$.reset(div_9);
			$.reset(div_8);

			var div_10 = $.sibling(div_8, 2);

			$.html(div_10, () => text($.get(doc).bodyHtml ?? $.get(doc).html), true);
			$.reset(div_10);
			$.reset(div_7);
			$.reset(article_1);

			$.template_effect(
				($0, $1, $2) => {
					$.set_attribute(div_9, 'aria-label', $0);
					$.set_attribute(button_2, 'title', $1);
					$.set_text(text_3, $2);
					$.set_attribute(span_7, 'data-state', $.get(copyFeedbackState));
					$.set_text(text_4, $.get(copyFeedback));
				},
				[
					() => labels().docsLabel,
					() => labels().copyPage,
					() => labels().copyPage
				]
			);

			$.delegated('click', button_2, () => copyMarkdown($.get(doc)));
			$.append($$anchor, article_1);
		};

		var alternate = ($$anchor) => {
			var div_11 = root_7();
			var text_6 = $.child(div_11, true);

			$.reset(div_11);
			$.template_effect(($0) => $.set_text(text_6, $0), [() => text($.get(p).emptyText, labels().noDocsFound)]);
			$.append($$anchor, div_11);
		};

		$.if(node_5, ($$render) => {
			if ($.get(p).doc && typeof $.get(p).doc === "object") $$render(consequent_4); else $$render(alternate, -1);
		});
	}

	$.reset(article);

	var node_8 = $.sibling(article, 2);

	{
		var consequent_5 = ($$anchor) => {
			const doc = $.derived(() => $.get(p).doc);

			const railProps = $.derived(() => ({
				items: $.get(doc).toc,
				markdownHref: markdownHref($.get(doc)),
				playgroundHref: playgroundHref($.get(doc)),
				label: labels().onThisPage,
				ariaLabel: labels().onThisPageAria,
				actionsLabel: labels().docsLabel,
				copyLabel: labels().copyPage,
				viewMarkdownLabel: labels().viewMarkdown,
				openLiveLabel: labels().openLive,
				markdownLabel: "Markdown",
				copyFeedback: $.get(copyFeedback),
				copyFeedbackState: $.get(copyFeedbackState),
				onCopy: () => copyMarkdown($.get(doc))
			}));

			DocRail($$anchor, {
				class: 'slex-docs-shell-rail',
				componentName: 'doc-rail',
				get ctx() {
					return $$props.ctx;
				},

				props: {
					subscribe: (run) => {
						run($.get(railProps));

						return () => {};
					}
				}
			});
		};

		$.if(node_8, ($$render) => {
			if ($.get(p).doc && typeof $.get(p).doc === "object") $$render(consequent_5);
		});
	}

	$.reset(section_1);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(button_1, 'aria-label', $0);
			$.set_attribute(button_1, 'title', $1);
		},
		[
			() => labels().openDocsNavigation,
			() => labels().openDocsNavigation
		]
	);

	$.delegated('click', button_1, function (...$$args) {
		docsSidebarUi.toggle?.apply(this, $$args);
	});

	$.append($$anchor, section_1);
	$.pop();
}

$.delegate(['click']);